import { Button, Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import { ModalSuccess } from "../modal";
import LayoutLogin from "../layoutLogin";
import { useState } from "react";
import { useAPIPublic } from "../../../tools/api";
import { useNavigate } from "react-router-dom";
import { _adr } from "../../../address";
import { convertPersian, validateInput } from "../../../tools/tools";
import { app_Cookie_Remove } from "../../../tools/services";
const ChangePassword = () => {
  const [t] = useTranslation("global");
  const [isProgress, setIsProgress] = useState(false);
  const { resetPassword } = useAPIPublic();
  const [isActiveSuccess, setIsActiveSuccess] = useState(false);
  const handleSubmit = async (param) => {
    setIsProgress(true);
    let payload = {
      newpassword: param.password,
    };
    let response = await resetPassword(payload);
    if (response) {
      setIsActiveSuccess(true);
      localStorage.clear();
    }
    setIsProgress(false);
  };
  return (
    <>
      <LayoutLogin>
        <div className="holder-title-form">
          <h3>رمز عبور جدید را وارد کنید</h3>
        </div>
        <Form name="normal_login" className="login-form" onFinish={handleSubmit}>
          <Form.Item name="password" rules={[validateInput({ t: t, type: "password" })]} className="input-normal">
            <Input.Password
              dir="ltr"
              prefix={<i className="icon-lock-normal"></i>}
              placeholder={t("form.password")}
              autoComplete="off"
              maxLength={32}
              onChange={(e) => {
                e.target.value = convertPersian(e.target.value);
              }}
            />
          </Form.Item>
          <Form.Item
            name="passwordconfirm"
            rules={[
              validateInput({
                t: t,
                type: "password",
              }),
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("validation.equalTo")));
                },
              }),
            ]}
            className="input-normal"
          >
            <div>
              <Input.Password
                dir="ltr"
                prefix={<i className="icon-lock-normal"></i>}
                placeholder={t("form.confirmpassword")}
                autoComplete="off"
                maxLength={32}
                onChange={(e) => {
                  e.target.value = convertPersian(e.target.value);
                }}
              />
            </div>
          </Form.Item>

          <Form.Item>
            <Button type="default" htmlType="submit" className={`btn-normal btn-aptel ${isProgress && "disabled"}`} disabled={isProgress} danger>
              {isProgress ? t("form.inProgress") : t("form.loginButton")}
            </Button>
          </Form.Item>
        </Form>
        <ModalSuccess action={isActiveSuccess} />
      </LayoutLogin>
    </>
  );
};

export default ChangePassword;
